var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 161,
    viewBox: "0 0 165 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_245_68579)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 165,
    height: 161,
    rx: 80.5,
    fill: "#FF7C44"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.9799 113.284C82.205 113.383 82.3807 113.46 82.5001 113.513L82.5482 113.489C84.1784 112.776 98.3744 106.518 102.833 102.894C105.261 100.874 107.195 98.3266 108.487 95.4452C109.779 92.5638 110.395 89.4252 110.288 86.2692V53.6483C102.533 49.5663 93.2524 47.4863 82.5001 47.4863C71.7478 47.4863 62.4216 49.5533 54.7126 53.6483V86.3056C54.6077 89.4607 55.2258 92.598 56.5199 95.4774C57.8139 98.3568 59.7495 100.902 62.1785 102.918C66.4023 106.433 78.8802 111.921 81.9799 113.284ZM99.6666 68.6893C96.1462 68.649 93.2524 71.4609 93.1926 74.9839L93.1679 74.9761C93.1679 77.5501 93.892 79.4689 97.8674 81.8011C99.9812 83.0816 100.876 83.9149 100.876 85.4255C100.898 85.8021 100.838 86.179 100.698 86.5294C100.558 86.8797 100.342 87.1948 100.066 87.4522C99.7904 87.7095 99.4611 87.9028 99.1019 88.018C98.7427 88.1333 98.3624 88.1678 97.9883 88.1191C96.2732 87.9966 94.6484 87.3032 93.3733 86.1496V90.5696C94.9823 91.527 96.8168 92.0398 98.689 92.0555C99.5785 92.1196 100.472 92.0008 101.313 91.7064C102.155 91.4119 102.928 90.9481 103.583 90.3435C104.239 89.7389 104.763 89.0064 105.125 88.1912C105.486 87.376 105.677 86.4953 105.684 85.6036C105.792 82.7878 104.995 80.7117 100.96 78.2937C100.819 78.2086 100.68 78.1259 100.544 78.0448C98.9464 77.0919 97.7386 76.3717 97.7829 74.7902C97.831 73.0742 99.2571 72.4827 100.622 72.4827C102.266 72.5629 103.817 73.2673 104.959 74.4522V70.2597C103.427 69.1444 101.559 68.5899 99.6666 68.6893ZM83.1878 72.5789C82.6158 72.575 82.0347 72.6959 81.4978 72.9299L81.4718 72.9312V87.7655C81.9736 87.954 82.5053 88.0515 83.0422 88.0554C85.8216 88.0554 87.1502 85.6387 87.1502 80.2268C87.1502 74.8149 85.9906 72.5789 83.1878 72.5789ZM76.6631 101.865H81.4978L81.4588 101.854V91.7292C82.1647 91.9268 82.8992 92.0204 83.6337 92.0074C89.0105 92.0074 92.0915 87.1623 92.0915 80.1306C92.0915 73.0989 88.926 68.7257 83.1631 68.7257C80.8751 68.648 78.6147 69.2447 76.6631 70.4417V101.865ZM59.7501 69.234V84.3608L59.7137 84.3504C59.7137 89.4724 62.1304 92.0594 66.9625 92.0594C69.5175 92.1524 72.0419 91.4791 74.2113 90.1263V69.2353H69.3792V87.3573C68.7058 87.7785 67.9102 87.993 67.1302 87.9735C64.9072 87.9735 64.5822 85.9429 64.5822 84.5779V69.234H59.7501ZM63.8581 100.96C59.5291 97.3504 57.1176 91.9372 57.3321 86.3056H57.3217V67.6272C72.4472 53.7588 91.5481 52.8384 107.706 54.3373V86.3173C107.814 89.095 107.282 91.8604 106.151 94.3996C105.019 96.9388 103.319 99.1836 101.181 100.96C97.35 104.116 85.7501 109.31 82.5261 110.736C79.2501 109.297 67.6281 104.041 63.8581 100.96Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_245_68579",
    x: -60,
    y: -60,
    width: 285,
    height: 281,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_245_68579"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_245_68579",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUps);
export default __webpack_public_path__ + "static/media/UPS.5ec1a3bd2258898d1b22cdf9de09e871.svg";
export { ForwardRef as ReactComponent };